import { render } from "./view-product.vue?vue&type=template&id=cec08388&scoped=true"
import script from "./view-product.vue?vue&type=script&lang=js"
export * from "./view-product.vue?vue&type=script&lang=js"

import "./view-product.vue?vue&type=style&index=0&id=cec08388&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cec08388"]])

export default __exports__